<template>
  <v-dialog
    :value="value"
    max-width="760"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="justify-center my-5 branch-title"
        >胸高直徑分枝轉換</v-card-title
      >
      <!-- <v-card-subtitle class="text-center"
        >回填至{{ targetLabel }}・單位：公分</v-card-subtitle
      > -->
      <v-card-text>
        <!-- <p>
          每個分枝填寫直徑或周長其中一項，另一項會自動換算。分枝只能新增；重新開啟視窗會重設為兩筆。
        </p> -->
        <v-form ref="branchForm" @submit.prevent="convert">
          <div
            v-for="(branch, index) in branches"
            :key="branch.id"
            class="branch-row"
          >
            <div class="branch-label">分枝 {{ index + 1 }}</div>
            <v-text-field
              :ref="'diameter-' + index"
              :value="branch.diameter"
              :aria-label="'分枝 ' + (index + 1) + ' 胸高直徑（公分）'"
              label="胸高直徑（公分）"
              inputmode="decimal"
              dense
              solo
              :hide-details="false"
              :rules="[() => validBranch(branch)]"
              @input="updateBranch(branch, 'diameter', $event)"
            />
            <v-text-field
              :value="branch.perimeter"
              :aria-label="'分枝 ' + (index + 1) + ' 胸高周長（公分）'"
              label="胸高周長（公分）"
              inputmode="decimal"
              dense
              solo
              :hide-details="false"
              @input="updateBranch(branch, 'perimeter', $event)"
            />
          </div>
        </v-form>
        <!-- <p class="text-center">
          等效胸高直徑 = √（各分枝直徑平方的總和），取小數點一位。
        </p> -->
        <v-alert v-if="error" type="error" dense role="alert">{{
          error
        }}</v-alert>
        <div class="branch-actions">
          <v-btn color="#FFF777" @click="addBranch">
            <v-icon>
              mdi-plus
            </v-icon>
            新增分枝
          </v-btn>
          <v-btn color="#FFF777" @click="convert">進行換算</v-btn>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="justify-center py-4">
        <v-btn color="#FFF777" @click="$emit('input', false)">關閉視窗</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  branchDiameter,
  convertBranches,
  isPositiveMeasurement,
} from "./measurement";

function emptyBranch(id) {
  return { id, diameter: "", perimeter: "", source: "diameter" };
}

export default {
  props: {
    value: Boolean,
    targetLabel: { type: String, default: "基準值" },
  },
  data: () => ({ branches: [emptyBranch(1), emptyBranch(2)], error: "" }),
  watch: {
    value(open) {
      if (open) {
        this.branches = [emptyBranch(1), emptyBranch(2)];
        this.error = "";
        this.$nextTick(() => {
          if (this.$refs.branchForm) this.$refs.branchForm.resetValidation();
          this.focusBranch(0);
        });
      }
    },
  },
  methods: {
    validBranch(branch) {
      const diameter = branchDiameter(branch);
      return (
        (Number.isFinite(diameter) && diameter > 0) ||
        "請輸入大於 0 的直徑或周長"
      );
    },
    focusBranch(index) {
      const fields = this.$refs["diameter-" + index];
      if (fields && fields[0]) fields[0].focus();
    },
    addBranch() {
      this.branches.push(emptyBranch(this.branches.length + 1));
      this.$nextTick(() => this.focusBranch(this.branches.length - 1));
    },
    updateBranch(branch, source, value) {
      branch.source = source;
      branch[source] = value;
      this.error = "";
      const other = source === "diameter" ? "perimeter" : "diameter";
      const converted =
        source === "diameter"
          ? Number(value) * Math.PI
          : Number(value) / Math.PI;
      branch[other] =
        isPositiveMeasurement(value) && Number.isFinite(converted)
          ? converted.toFixed(1)
          : "";
    },
    convert() {
      if (!this.$refs.branchForm.validate()) {
        this.focusBranch(
          this.branches.findIndex(
            (branch) => this.validBranch(branch) !== true,
          ),
        );
        return;
      }
      try {
        this.$emit("converted", convertBranches(this.branches));
        this.$emit("input", false);
      } catch (error) {
        this.error = error.message;
      }
    },
  },
};
</script>

<style scoped>
.branch-title {
  font-size: clamp(1.2rem, 2.1vw, 2rem) !important;
  line-height: 1.1;
  color: #0f7c1f;
  font-weight: 700 !important;
  word-break: normal;
}
.branch-row {
  display: grid;
  grid-template-columns: 5rem minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  padding-top: 12px;
}
.branch-label {
  padding-top: 8px;
  font-weight: 700;
  color: #557552;
}
.branch-actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 0;
}
@media (max-width: 600px) {
  .branch-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }
  .branch-label {
    padding: 0 0 12px;
  }
}
</style>
